module.exports = __webpack_public_path__ + "media/images/flags/FR-48a6886fac735a00887ae6dbe763419b.svg";